module.exports = __webpack_public_path__ + "img/text_align_right.74b9d175.svg";